import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from '../../../core/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';
import { QrcodeConfig } from '../payment-method/payment-method.type';

@Component({
  selector: 'tax-qrcode-payment-method',
  templateUrl: './qrcode-payment-method.component.html',
  styleUrls: ['./qrcode-payment-method.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    NgIf,
    TranslateModule,
    FormsModule,
    SharedModule,
    QRCodeModule,
  ],
})

export class QrcodePaymentMethodComponent {
  @Input() billingAccountNumber = '';
  @Input() qrcode?: QrcodeConfig['qrCodeStartData'];
  @Input() paymentMethodName?: QrcodeConfig['name'];
}
